// import { datadogRum } from '@datadog/browser-rum';
import getConfig from 'next/config';
import { useEffect } from 'react';

export const useDatadog = () => {
  const { publicRuntimeConfig } = getConfig();

  useEffect(() => {
    if (
      publicRuntimeConfig?.environment === 'development' ||
      publicRuntimeConfig?.environment === 'uat'
    ) {
      // datadogRum.init({
      //   applicationId: publicRuntimeConfig?.dataDog?.applicationId,
      //   clientToken: publicRuntimeConfig?.dataDog?.clientToken,
      //   site: 'datadoghq.com',
      //   service: publicRuntimeConfig?.dataDog?.service,
      //   env: publicRuntimeConfig?.environment,
      //   version: publicRuntimeConfig?.version,
      //   sampleRate: 100,
      //   sessionReplaySampleRate: 0,
      //   trackResources: true,
      //   trackLongTasks: true,
      //   trackInteractions: true,
      //   defaultPrivacyLevel: 'mask-user-input',
      // });
    }

    /* A method that starts recording the session. */
    /* Starting the session replay recording. */
    // datadogRum.startSessionReplayRecording();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {};
};
